import { render, staticRenderFns } from "./AddPAHeader.vue?vue&type=template&id=41c2c92e&scoped=true"
import script from "./AddPAHeader.vue?vue&type=script&lang=js"
export * from "./AddPAHeader.vue?vue&type=script&lang=js"
import style0 from "./AddPAHeader.vue?vue&type=style&index=0&id=41c2c92e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c2c92e",
  null
  
)

export default component.exports